import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  infoBanner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    p: "16px",
    width: "100%",
    color: capitalDesignTokens.foundations.colors.gray700,
  },
});
